export default __webpack_public_path__ + "static/media/CirclePlus.c84feef0.svg";